export const pipelineKeys = {
  orderLayers: (storyId: string) => ['pipeline', 'order-layers', storyId] as const,
  /** one order by its id (a link that carries ?plan=<orderId>) */
  order: (orderId: string) => ['pipeline', 'order', orderId] as const,
  /** the family's stories with a running order (story list «Создаётся…» badge) */
  running: () => ['pipeline', 'running'] as const,
  /** stale artifacts of a story (edits after ready, «Обновить») */
  stale: (storyId: string) => ['pipeline', 'stale', storyId] as const,
};
